import { Typography, message, Input, Button, Space, Modal, Tooltip, Dropdown, Menu } from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  CopyOutlined,
  AuditOutlined,
  ExportOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { useState, useEffect } from "react";
import VerificationsIndex from "./VerificationsIndex";
import AddVerificationForm from "./forms/general/AddVerificationForm";
import axios from "axios";
import moment from "moment";
import { useAuth } from "../../layout/auth";

const CARD = {
  background: "#fff",
  border: "0.5px solid rgba(0,0,0,0.08)",
  borderRadius: "12px",
};

export default function Verifications() {
  const auth = useAuth();

  const [selectedVerification, setSelectedVerification] = useState(null);
  const [verifications, setVerifications] = useState();
  const [currentData, setCurrentData] = useState([]);
  const [search, setSearch] = useState();
  const [filteredVerifications, setFilteredVerifications] = useState();
  const [loading, setLoading] = useState(false);
  const [agregarVerificacionVisible, setAgregarVerificacionVisible] = useState(false);
  const [clonarVerificacionVisible, setClonarVerificacionVisible] = useState(false);
  const [eliminarVerificacionVisible, setEliminarVerificacionVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/verificaciones`, {
        params: { u: auth.UvieID },
      })
      .then((res) => {
        setVerifications(res.data);
        setCurrentData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = verifications.filter((verification) => {
        return verification?.ControlInterno?.toString().toLowerCase().includes(search.toLowerCase());
      });
      setFilteredVerifications(filtered);
      setCurrentData(filtered);
    } else {
      setFilteredVerifications(verifications);
      setCurrentData(verifications);
    }
  }, [search, verifications]);

  const handleExport = () => {
    if (!currentData?.length) return message.warning("No hay datos para exportar");

    const headers = [
      "Folio",
      "Fecha",
      "Descripción",
      "Cliente",
      "Razón Social",
      "Tensión (V)",
      "Carga (kW)",
      "Alcance (kW)",
      "Capacidad (kVA)",
      "Monto",
    ];

    const escapeCSV = (val) => {
      if (val === null || val === undefined) return "";
      const s = String(val);
      if (s.includes(",") || s.includes('"') || s.includes("\n")) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    };

    const rows = currentData.map((v) => [
      escapeCSV(v.ControlInterno),
      escapeCSV(v.FechaCreacion ? moment.utc(v.FechaCreacion).format("DD/MM/YYYY") : ""),
      escapeCSV(v.DescripcionBreve),
      escapeCSV(v.NombreCliente),
      escapeCSV(v.NombreCompleto),
      escapeCSV(v.TensionElectricaSuministro),
      escapeCSV(v.CargaInstalada),
      escapeCSV(v.AlcanceVerificacion),
      escapeCSV(v.Capacidad),
      escapeCSV(v.Monto),
    ]);

    const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `verificaciones_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    message.success("Exportado correctamente");
  };

  const mobileMenuItems = [
    {
      key: "clonar",
      label: "Clonar",
      icon: <CopyOutlined />,
      onClick: () => {
        if (selectedVerification) {
          setClonarVerificacionVisible(true);
        } else {
          message.error("Seleccione una verificación para clonar");
        }
      },
    },
    {
      key: "exportar",
      label: "Exportar",
      icon: <ExportOutlined />,
      onClick: handleExport,
    },
    {
      key: "eliminar",
      label: "Eliminar",
      icon: <DeleteOutlined />,
      danger: true,
      onClick: () => {
        if (auth.rol !== "director") {
          message.error("No tiene permisos para eliminar verificaciones");
        } else if (selectedVerification) {
          setEliminarVerificacionVisible(true);
        } else {
          message.error("Seleccione una verificación para eliminar");
        }
      },
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>

      {/* ── Header card ── */}
      <div style={{ ...CARD, padding: 0 }}>

        {/* Title row */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "18px 20px 14px",
          borderBottom: "0.5px solid rgba(0,0,0,0.06)",
          flexWrap: "wrap",
        }}>

          {/* Icon badge */}
          <div style={{
            width: 38,
            height: 38,
            borderRadius: 10,
            background: "rgba(24,144,255,0.08)",
            border: "0.5px solid rgba(24,144,255,0.18)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}>
            <AuditOutlined style={{ fontSize: 17, color: "#1677ff" }} />
          </div>

          {/* Title + subtitle */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: "rgba(0,0,0,0.88)", lineHeight: 1.3 }}>
              Verificaciones
            </div>
            <div style={{ fontSize: 12, color: "rgba(0,0,0,0.38)", marginTop: 1 }}>
              Gestión y seguimiento de verificaciones
            </div>
          </div>

          {/* Desktop actions */}
          <Space size={8} className="vf-desktop-actions" style={{ flexShrink: 0 }}>
            <Tooltip title="Agregar verificación">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ fontSize: 13, fontWeight: 500 }}
                onClick={() => setAgregarVerificacionVisible(true)}
              >
                Agregar
              </Button>
            </Tooltip>
            <Tooltip title="Clonar verificación seleccionada">
              <Button
                icon={<CopyOutlined />}
                style={{ fontSize: 13 }}
                onClick={() => {
                  if (selectedVerification) {
                    setClonarVerificacionVisible(true);
                  } else {
                    message.error("Seleccione una verificación para clonar");
                  }
                }}
              >
                Clonar
              </Button>
            </Tooltip>
            <Tooltip title="Exportar como CSV">
              <Button
                icon={<ExportOutlined />}
                style={{ fontSize: 13 }}
                onClick={handleExport}
              >
                Exportar
              </Button>
            </Tooltip>
            <Tooltip title="Eliminar verificación seleccionada">
              <Button
                danger
                icon={<DeleteOutlined />}
                style={{ fontSize: 13 }}
                onClick={() => {
                  if (auth.rol !== "director") {
                    message.error("No tiene permisos para eliminar verificaciones");
                  } else if (selectedVerification) {
                    setEliminarVerificacionVisible(true);
                  } else {
                    message.error("Seleccione una verificación para eliminar");
                  }
                }}
              >
                Eliminar
              </Button>
            </Tooltip>
          </Space>

          {/* Mobile actions */}
          <Space size={8} className="vf-mobile-actions" style={{ flexShrink: 0 }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ fontSize: 13, fontWeight: 500 }}
              onClick={() => setAgregarVerificacionVisible(true)}
            >
              Agregar
            </Button>
            <Dropdown overlay={<Menu items={mobileMenuItems} />} trigger={["click"]} placement="bottomRight">
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        </div>

        {/* Search row */}
        <div style={{ padding: "12px 20px" }}>
          <Input.Search
            placeholder="Buscar por control interno…"
            onSearch={(value) => setSearch(value)}
            onChange={(e) => { if (!e.target.value) setSearch(""); }}
            allowClear
            loading={loading}
            style={{ maxWidth: 380 }}
          />
        </div>
      </div>

      {/* ── Table card ── */}
      <div style={{ ...CARD, overflow: "hidden" }}>
        <VerificationsIndex
          verifications={search ? filteredVerifications : verifications}
          loading={loading}
          setSelectedVerification={setSelectedVerification}
          onDataChange={setCurrentData}
        />
      </div>

      {/* Responsive */}
      <style>{`
        .vf-mobile-actions  { display: none !important; }
        .vf-desktop-actions { display: flex !important; }
        @media (max-width: 600px) {
          .vf-mobile-actions  { display: flex !important; }
          .vf-desktop-actions { display: none !important; }
        }
      `}</style>

      {/* ── Add form — exactly as original ── */}
      <AddVerificationForm
        visible={agregarVerificacionVisible}
        setVisible={setAgregarVerificacionVisible}
        setVerifications={setVerifications}
        loading={loading}
        setLoading={setLoading}
      />

      {/* ── Clone modal — exactly as original ── */}
      <Modal
        title="Clonar verificación"
        visible={clonarVerificacionVisible}
        onOk={() => {
          setLoading(true);
          setClonarVerificacionVisible(false);
          axios
            .post(`${process.env.REACT_APP_API_URL}/verificaciones/clone/1/${selectedVerification}`)
            .then((res) => {
              setLoading(false);
              message.success("Verificación clonada exitosamente");
              axios
                .get(`${process.env.REACT_APP_API_URL}/verificaciones`)
                .then((res) => {
                  setVerifications(res.data);
                  message.success("Lista de verificaciones actualizada");
                })
                .catch((err) => {
                  setLoading(false);
                  console.log(err);
                  message.error("Error al actualizar lista de verificaciones");
                });
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
              message.error("Error al clonar la verificación");
            });
        }}
        onCancel={() => setClonarVerificacionVisible(false)}
        okButtonProps={{ loading: loading }}
      >
        <Typography.Title level={4}>¿Está seguro de que desea clonar la verificación?</Typography.Title>
        <Typography.Text>
          Esta acción crea una copia de la verificación seleccionada, incluyendo sus visitas. Puede borrarse más adelante si así lo desea.
        </Typography.Text>
      </Modal>

      {/* ── Delete modal — exactly as original ── */}
      <Modal
        title="Eliminar verificación"
        visible={eliminarVerificacionVisible}
        onOk={() => {
          setLoading(true);
          setEliminarVerificacionVisible(false);
          axios
            .delete(`${process.env.REACT_APP_API_URL}/verificaciones/${selectedVerification}`)
            .then((res) => {
              setLoading(false);
              message.success("Verificación eliminada");
              axios
                .get(`${process.env.REACT_APP_API_URL}/verificaciones`)
                .then((res) => {
                  setVerifications(res.data);
                  message.success("Lista de verificaciones actualizada");
                })
                .catch((err) => {
                  setLoading(false);
                  console.log(err);
                  message.error("Error al actualizar lista de verificaciones");
                });
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
              message.error("Error al eliminar verificación");
            });
        }}
        onCancel={() => setEliminarVerificacionVisible(false)}
      >
        <Typography.Title level={4} style={{ textAlign: "center", color: "red" }}>
          ¿Está seguro de que desea eliminar la verificación?
        </Typography.Title>
        <Typography.Text>
          Esta acción no se puede deshacer. Si continúa, se eliminará la verificación seleccionada.
        </Typography.Text>
      </Modal>

    </div>
  );
}